export const paramsToRemove = [
  'merch_manage_alerts',
  'refSource',
  'searchEvent',
  'searchSource',
  'utm_term'
];

export const utmContentToRemove = ['saved_search_preferences'];
